export const shiftInstructionList=[
    {
     "API_user": "BF",
     "Read": "No",
     "Instruction_name": "Long Term work Pending",
     "Created_by": "supervisor",
     "Valid_from_date": "30/01/2020",
     "Valid_to_date": "30/09/2020"
    },
    {
     "API_user": "BF-O",
     "Read": "No",
     "Instruction_name": "Long Term work Pending",
     "Created_by": "supervisor",
     "Valid_from_date": "30/01/2020",
     "Valid_to_date": "30/09/2020"
    },
    {
     "API_user": "Bfl",
     "Read": "No",
     "Instruction_name": "Long Term work Pending",
     "Created_by": "supervisor",
     "Valid_from_date": "30/01/2020",
     "Valid_to_date": "30/09/2020"
    }
   ]
   